import styled from "styled-components";

export const HeaderWrapper = styled.div`
  padding-bottom: 70px;
`;

export const HeaderLeftBox = styled.div`
  float: left;
`;

export const HeaderRightBox = styled.div`
  float: right;
`;

export const NameBox = styled.div`
  font-size: large;
  font-weight: bold;
`;

export const TextBox = styled.div`
  font-size: small;
`;
